<template>
  <div>
    <h1>contact</h1>
    <form>

    </form>
  </div>
</template>
    
<script>
  export default {
    name: 'ContactForm',
  }
</script>
  
<style scoped>

</style>